import useMediaQuery from 'hooks/useMediaQuery';

import { Footer, Header, If } from '@mobi/ds';

import AnchorButton from 'components/AnchorButton';
import Faq from 'components/Faq';
import HeaderMobile from 'components/HeaderMobile';
import ReCAPTCHAPolicy from 'components/ReCAPTCHAPolicy';

import routing from 'utils/routing';

const WrapperLP = ({ headerLogo, children, faq, anchorRef, customLogo }) => {
  const isDesktop = useMediaQuery('desktop');

  const FOOTER_LINKS = {
    urlHelpPage:
      'https://www.itau.com.br/atendimento-itau/para-voce/conta-corrente',
  };

  return (
    <main>
      <If
        condition={isDesktop}
        renderIf={
          <>
            {customLogo ? (
              <Header
                handleOpenAccountLink={(e) => routing.handleOpenAccountLink(e)}
                logoUrl={customLogo}
              />
            ) : (
              <Header
                handleOpenAccountLink={(e) => routing.handleOpenAccountLink(e)}
              />
            )}
          </>
        }
        renderElse={<HeaderMobile logo={headerLogo} />}
      />

      {children}

      <If condition={faq} renderIf={<Faq data={faq} />} />

      <ReCAPTCHAPolicy />

      <Footer links={FOOTER_LINKS} />

      <If
        condition={!isDesktop}
        renderIf={<AnchorButton scrollRef={anchorRef} />}
      />
    </main>
  );
};

export default WrapperLP;
